import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as Utils from '../../commons/utils/Utils';
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody
} from '@material-ui/core';
import { StyledTableCell } from '../../commons/utils/TableStyles';
import Timezone from '../../commons/timezone/Timezone.js';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';

const FacturasAbmHistorialEstados = (props) => {
  const [loading, setLoading] = useState(false);
  const [historial, setHistorial] = useState([]);

  useEffect(() => {
    if (!props.facturaId) return;
    setLoading(true);
    Utils.getData('/facturas/' + props.facturaId + '/historial-estados')
      .then((data) => {
        setHistorial(data || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [props.facturaId]);

  return (
    <div className="card">
      <div className="card-content">
        <div className="card-body">
          <TableContainer>
            <Table aria-label="historial estados table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="left">
                    <FormattedMessage id="facturasAbmHistorialEstados.col_fecha" defaultMessage="Fecha y Hora" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormattedMessage id="facturasAbmHistorialEstados.col_estado_anterior" defaultMessage="Estado Origen" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormattedMessage id="facturasAbmHistorialEstados.col_estado" defaultMessage="Estado Destino" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormattedMessage id="facturasAbmHistorialEstados.col_usuario" defaultMessage="Persona Modificación" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormattedMessage id="facturasAbmHistorialEstados.col_observaciones" defaultMessage="Observaciones" />
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && (
                  <TableRow>
                    <StyledTableCell colSpan={5} align="center">
                      <FormattedMessage id="Cargando" defaultMessage="Cargando" />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading && historial.length === 0 && (
                  <TableRow>
                    <StyledTableCell colSpan={5} align="center">
                      <FormattedMessage id="facturasAbmHistorialEstados.empty" defaultMessage="No hay transiciones de estado registradas." />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading && historial.map((item, key) => (
                  <TableRow key={key}>
                    <StyledTableCell align="left">{LocaleFormat.formatDateTime(Timezone.getDateForClient(item.created_at))}</StyledTableCell>
                    <StyledTableCell align="left">{item.estado_anterior || '—'}</StyledTableCell>
                    <StyledTableCell align="left">{item.estado}</StyledTableCell>
                    <StyledTableCell align="left">{item.usuario_nombre_apellido || '—'}</StyledTableCell>
                    <StyledTableCell align="left">{item.observaciones || '—'}</StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
};

export default FacturasAbmHistorialEstados;
